import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import "./GenerateContractModal.css";

export default function GenerateContractModal({
  isOpen,
  onClose,
  locale = "kz",
  token,
  orderId,
  externalExpertId,
  expertName,
  applications = [], // 👈 теперь приходит список заявок
  onCreated = () => {},
}) {
  // ✅ хуки всегда наверху
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  // создаём массив строк при открытии
 useEffect(() => {
  if (applications?.length) {
    setRows(applications.map(a => ({
      id: a.id, title: a.title, baspa_tabak: "", duration: "", page_count: ""
    })));
  } else {
    setRows([{ id: "single", title: "", baspa_tabak: "", duration: "", page_count: "" }]);
  }
}, [applications, isOpen]);


  const t = {
    kz: {
      title: "Келісім шарт жасау",
      expert: "Сарапшы",
      appTitle: "Өтініш",
      tabak: "Баспа табақ",
      duration: "Минут",
      pages: "Бет саны",
      save: "Жасау",
      cancel: "Болдырмау",
      success: "✅ Келісімшарт жасалды",
      error: "Қате пайда болды",
    },
    ru: {
      title: "Создать договор",
      expert: "Эксперт",
      appTitle: "Заявка",
      tabak: "Печатный лист",
      duration: "Минут",
      pages: "Кол-во страниц",
      save: "Создать",
      cancel: "Отмена",
      success: "✅ Договор создан",
      error: "Произошла ошибка",
    },
  }[locale];

  if (!isOpen) return null;

  const handleChange = (idx, field, value) => {
    setRows((prev) => {
      const newArr = [...prev];
      newArr[idx][field] = value;
      return newArr;
    });
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const body = {
        external_expert_id: externalExpertId,
        baspa_tabaks: rows.map((r) => r.baspa_tabak || ""),
        durations: rows.map((r) => r.duration || ""),
        page_counts: rows.map((r) => r.page_count || ""),
      };

      await axios.post(`/orders/${orderId}/generate-contract`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert(t.success);
      onCreated();
      onClose();
    } catch (e) {
      console.error(e);
      alert(t.error);
    } finally {
      setLoading(false);
    }
  };

  console.log("GCM applications prop:", applications, "rows:", rows);

  return (
    <div className="gc-backdrop" onClick={onClose}>
      <div className="gc-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gc-header">
          <h3>{t.title}</h3>
          <button className="gc-close" onClick={onClose}>×</button>
        </div>

        <div className="gc-body">
          <p><b>{t.expert}:</b> {expertName}</p>

          {rows.map((r, idx) => (
            <div key={r.id} className="gc-app-row">
              <div className="gc-app-title">
                <b>{t.appTitle}:</b> {r.title}
              </div>

              <div className="gc-row">
                <label>{t.pages}</label>
                <input
                  type="text"
                  value={r.page_count}
                  onChange={(e) => handleChange(idx, "page_count", e.target.value)}
                />
              </div>

              <div className="gc-row">
                <label>{t.tabak}</label>
                <input
                  type="text"
                  value={r.baspa_tabak}
                  onChange={(e) => handleChange(idx, "baspa_tabak", e.target.value)}
                />
              </div>

              <div className="gc-row">
                <label>{t.duration}</label>
                <input
                  type="text"
                  value={r.duration}
                  onChange={(e) => handleChange(idx, "duration", e.target.value)}
                />
              </div>

              

              <hr className="gc-divider" />
            </div>
          ))}
        </div>

        <div className="gc-footer">
          <button className="gc-btn" onClick={onClose}>
            {t.cancel}
          </button>
          <button
            className="gc-btn gc-btn-primary"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? "..." : t.save}
          </button>
        </div>
      </div>
    </div>
  );
}
